export default [
    {
      path: "/settings/messaging",
      name: "Messaging",
      component: () => import("@/views/3pl/Settings/Messaging/index.vue"),
    },
    {
        path: "/settings/messaging/survey",
        name: "MessagingSurvey",
        component: () => import("@/views/3pl/Settings/Messaging/Survey.vue"),
      },
  ];
  